import React, { Component } from "react";
import ReactTable from "react-table";
import PropTypes from "prop-types";
import "react-table/react-table.css";
import * as moment from "moment";
import "moment/locale/pt-br";

export default class TBLPedidosEntregadores extends Component {
  constructor(props) {
    super(props);
    this.columns = [
      {
        Header: "Código",
        accessor: "codigo",
        width: 120,
        className: "center",
      },
      {
        Header: "Data",
        accessor: "createdAt",
        Cell: (props) => (
          <span>
            {moment(props.value).format("l")} {moment(props.value).format("LT")}
          </span>
        ),
        className: "center",
      },
      {
        Header: "Entregador",
        accessor: "entregador",
        Cell: (props) => <span>{props.value ? props.value.nome : null}</span>,
        className: "center",
      },
      {
        Header: "Estabelecimento",
        accessor: "estabelecimento",
        Cell: (props) => <span>{props.value ? props.value.nome_fantasia : null}</span>,
        className: "center",
      },
      {
        Header: "Valor Frete",
        accessor: "valor_frete",
        Cell: (props) => <span>R$ {parseFloat(props.value).toFixed(2)}</span>,
        className: "right",
      },
      {
        Header: "% Entregador",
        accessor: "valor_entregador",
        Cell: (props) => <span>R$ {parseFloat(props.value).toFixed(2)}</span>,
        className: "right",
      },
      {
        Header: "% iFeira",
        accessor: "valor_ifeira",
        Cell: (props) => <span>R$ {parseFloat(props.value).toFixed(2)}</span>,
        className: "right",
      },
    ];
  }

  render() {
    const { data, loading, showPagination, limit } = this.props;
    return (
      <ReactTable
        data={data}
        className="-striped -highlight"
        columns={this.columns}
        resizable
        style={{ height: 572, maxHeight: 572 }}
        showPagination={showPagination}
        defaultPageSize={limit}
        loading={loading}
        previousText="Anterior"
        nextText="Próximo"
        loadingText="Carregando pedidos..."
        noDataText="Nenhum pedido encontrado!"
        pageText="Página"
        ofText="de"
        rowsText="linhas"
      />
    );
  }
}

TBLPedidosEntregadores.propTypes = {
  data: PropTypes.array,
  dataCallback: PropTypes.func,
  showPagination: PropTypes.bool,
  handleShowAlert: PropTypes.func,
  getPedidos: PropTypes.func,
  limit: PropTypes.number,
  pages: PropTypes.number,
  loading: PropTypes.bool,
  changePage: PropTypes.func,
};
